import { Routes } from "@angular/router";
import { authGuard } from "./guards/auth.guard";
import { LayoutComponent } from "./components/layout/layout.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full", // Redirect empty path to login page
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "manuals-dashboard",
        canActivate: [authGuard],
        loadComponent: () =>
          import(
            "./components/dashboard/manuals-board/manuals-board.component"
          ).then((m) => m.ManualsBoard),
      },
      {
        path: "new-analysis",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./components/new-analysis/new-analysis.component").then(
            (m) => m.NewAnalysisComponent
          ),
      },
      {
        path: "jobs-dashboard",
        canActivate: [authGuard],
        runGuardsAndResolvers: 'always',
        loadComponent: () =>
          import(
            "./components/jobs-iframe/jobs-iframe.component"
          ).then((m) => m.JobsIframeComponent),
      },    
      //{  
      //   path: "app-results",
      //   canActivate: [authGuard],
      //   loadComponent: () =>
      //   import("./components/results/results.component").then(
      //        (m) => m.ResultsComponent
      //      ),
      // },
      {
        path: "manage-users",
        canActivate: [authGuard],
        loadComponent: () =>
          import("./components/manage-users/manage-users.component").then(
            (m) => m.ManageUsersComponent
          ),
      },
    ],
  },
  {
    path: "auth/login",
    loadComponent: () =>
      import("./components/auth/login/login.component").then(
        (m) => m.LoginComponent
      ),
  },
];
